var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6V9.38461V9.4C2 11.6091 3.79086 13.4 6 13.4H9.4C11.6091 13.4 13.4 11.6091 13.4 9.4V6C13.4 3.79086 11.6091 2 9.4 2H9.38461H6ZM6 0C2.68629 0 0 2.68629 0 6V9.38461C0 12.6983 2.68629 15.3846 6 15.3846H9.38461C10.6824 15.3846 11.8839 14.9726 12.8655 14.2723L16.2942 17.7009C16.6827 18.0894 17.3125 18.0894 17.701 17.7009C18.0894 17.3125 18.0894 16.6826 17.701 16.2942L14.2723 12.8655C14.9726 11.8839 15.3846 10.6823 15.3846 9.38461V6C15.3846 2.68629 12.6983 0 9.38461 0H6Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.10be778f2f1c64a2b72acaa4705bbe93.svg";
export { ForwardRef as ReactComponent };